import { delay } from 'redux-saga';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import { flow } from '../modules/flow';
import { actions, types, consts } from '../modules/solicitacoes';
import * as solicitacoesService from '../../commons/services/solicitacoes';

export default function* solicitacoesSaga() {
  yield takeEvery(types.GET_PENDENCIAS.REQUEST, handleBuscaPendencias);
  yield takeEvery(types.GET_CONCLUIDAS.REQUEST, handleBuscaConcluidas);
  yield takeEvery(types.GET_BYID.REQUEST, handleBuscaPorId);
}

function* handleBuscaPendencias(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [{ data }] = yield all([
        call(solicitacoesService.getSolicitacoes, consts.STATUS_SOLICITACAO.EM_ANDAMENTO),
        call(delay, 750)
      ]);

      yield put(actions.getSolicitacoesPendentes.receive(data));
    }
  });
}

function* handleBuscaConcluidas(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [{ data }] = yield all([
        call(solicitacoesService.getSolicitacoes, consts.STATUS_SOLICITACAO.FINALIZADA),
        call(delay, 750)
      ]);

      yield put(actions.getSolicitacoesConcluidas.receive(data));
    }
  });
}

function* handleBuscaPorId(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [{ data }] = yield all([
        call(solicitacoesService.getSolicitacao, action.payload),
        call(delay, 750)
      ]);

      yield put(actions.getSolicitacao.receive(data));
    }
  });
}
